import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Slider from 'react-slick';
import { AppTheme } from '../styles/AppTheme';
import { CommonStyles } from '../styles/Styles';
import Button from '@material-ui/core/Button';
import { red } from '@material-ui/core/colors';

export class BannerComponent extends Component {
  constructor(props) {
    super(props);
    this.settings = {
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToScroll: 1,
      dotsClass: 'slick-dots',
      appendDots: dots => (
        <div
          style={{
            bottom: 0,
          }}
        >
          <ul style={{ margin: '0px' }}> {dots} </ul>
        </div>
      ),
    }
  }

  render() {
    return (
      <Slider
        {...this.settings}
        className={css(Styles.sliderContainer)}
      >
        {
          this.props.data.length > 0 &&
      this.props.data.map((item, index) => {
        return (
          <div key={index}>
            <div
              style={{ background: `url(${item.image})`}}
              className={css(CommonStyles.findOutMoreTile)}
            >
              <div className={css(CommonStyles.findOutMoreSubTile)}>
                <h3
                  className={css(CommonStyles.findOutMoreTite)}>
                  {item.title}
                </h3>
                <a href={item.link} target='_blank' className={css(CommonStyles.link)}>
                  <Button
                    variant='contained'
                    className={css(CommonStyles.findOutMoreButton)}>
                  FIND OUT MORE
                  </Button>
                </a>
              </div>
            </div >
          </div>
        )
      })
        }
      </Slider >
    );
  }
}


const Styles = StyleSheet.create({
  sliderContainer: {
    display: 'flex',
    width: '100%',
    marginTop: 30,
    padding: 0
  },
})


// WEBPACK FOOTER //
// ./src/components/BannerComponent.js